export default {"src":"/_next/static/media/logo.d6165220.svg","height":100,"width":330};